export default __webpack_public_path__ + "static/media/jen-health.ac0a0030.svg";